import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { UpdateCostCenterPriceDetailModel } from 'src/app/models/others/update-cost-center-price-detail.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { CostCenterSelectionTableModel } from 'src/app/models/tables/archive/cost-center-selection-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UpdateCostCenterPriceDetailService {

  constructor(private _httpClient: HttpClient) { }

  createAsync(updateCostCenterPriceDetailContract: UpdateCostCenterPriceDetailModel): Observable<UpdateCostCenterPriceDetailModel> {
    return this._httpClient.post<UpdateCostCenterPriceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPriceDetail.CreateAsync}`,
      updateCostCenterPriceDetailContract);
  }

  createDetails(updateCostCenterPriceDetails: Array<UpdateCostCenterPriceDetailModel>): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPriceDetail.CreateDetailsAsync}`,
      updateCostCenterPriceDetails);
  }

  deleteAsync(updateCostCenterPriceDetailId: number): Observable<UpdateCostCenterPriceDetailModel> {
    return this._httpClient.delete<UpdateCostCenterPriceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPriceDetail.DeleteAsync}/${updateCostCenterPriceDetailId}`);
  }

  deleteSomeDetailsAsync(updateCostCenterPriceDetails: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPriceDetail.DeleteSomeDetailsAsync}`,
      updateCostCenterPriceDetails);
  }

  getAllCostCenters(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<CostCenterSelectionTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<CostCenterSelectionTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPriceDetail.GetAllCostCentersAsync}`,
      filters, { params: params }
    );
  }

  getByIdAsync(updateCostCenterPriceDetailId: number): Observable<UpdateCostCenterPriceDetailModel> {
    return this._httpClient.get<UpdateCostCenterPriceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPriceDetail.GetByIdAsync}/${updateCostCenterPriceDetailId}`);
  }

  getColumnsForCaptureTable(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPriceDetail.GetColumnsForCaptureTableAsync}`);
  }

  getColumnsForCostCenters(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPriceDetail.GetColumnsForCostCentersTableAsync}`);
  }

  getUpdateCostCenterPriceDetailsForCaptureTable(page: number, limit: number, columnSort: string | null, ascendant: boolean, updateCostCenterPriceId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('updateCostCenterPriceId', updateCostCenterPriceId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPriceDetail.GetUpdateCostCenterPriceDetailsForCaptureTableAsync}`,
      { params: params }
    );
  }

  getUpdateCostCenterPriceDetailByKeys(getUpdateCostCenterPriceId: number, costCenterId: number): Observable<UpdateCostCenterPriceDetailModel> {
    const params = new HttpParams().set('getUpdateCostCenterPriceId', getUpdateCostCenterPriceId).set('costCenterId', costCenterId);
    return this._httpClient.get<UpdateCostCenterPriceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPriceDetail.GetUpdateCostCenterPriceDetailByKeysAsync}`,
      { params: params }
    );
  }

  updateAsync(masterSolutionDetailContract: UpdateCostCenterPriceDetailModel): Observable<UpdateCostCenterPriceDetailModel> {
    return this._httpClient.put<UpdateCostCenterPriceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.updateCostCenterPriceDetail.UpdateAsync}`,
      masterSolutionDetailContract);
  }
}
